export default __webpack_public_path__ + "static/media/Delivery.0a0bb025.png";